module.exports = __webpack_public_path__ + "img/vertical_4_7_5.44688510.png";